//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Swiper from 'swiper'
    import { formatDate } from "@/javascript/formatDate"
    import calendar from '@/components/public-components/price-calendar/index.vue'
    import payPublic from '@/javascript/payPublic'
    import util from "@//javascript/util"
    import checkbox from '@/components/public-components/check-box/index.vue'
    import contactList from '@/components/public-components/contactList/index.vue'
    import loadedTip from '@/components/public-components/loaded-tip/index.vue'
import { log } from 'util'

    export default {
        name: 'ticketHjly',
        components: {
            calendar,
            checkbox,
            contactList,
            loadedTip
        },
        data() {
            return {
                minHeight: 0,
                coastMxPump: false,
                addPeoplePump: false,
                But1: false,
                But2: false,
                selectIndex: -1,
                changeIndex: -1,
                count: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).count ? JSON.parse(localStorage.getItem('dateObj')).count : 1, // 门票数量
                price: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).price ? JSON.parse(localStorage.getItem('dateObj')).price : 0, // 门票单价
                discount: null,  // 折扣
                coupon: null, // 满减
                contactsList: [], //常用联系人列表
                playersList: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).playersList ? JSON.parse(localStorage.getItem('dateObj')).playersList : [],
                ticketInfo: {},
                curticket: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).curticket ? JSON.parse(localStorage.getItem('dateObj')).curticket : -1,
                ticketsCalenda: [],
                orderPeople:  localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).orderPeople ? JSON.parse(localStorage.getItem('dateObj')).orderPeople : null, // 预定人信息
                noticeShow: false,
                visibility: false,
                ticketSwiper: null,
                chooseData:  localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).chooseData ? JSON.parse(localStorage.getItem('dateObj')).chooseData : '',
                ticketHjlyVO: '',
                preferenShow: false,
                preferentialList: [],
                pageNo: 0,
                pageSize: 10,
                commodityPrices: '',
                couponCodeList: [],
                preShow: '暂无优惠券',
                preColorShow: false,
                orderCard: [],
                playCard: [],
                editId: '', // 编辑联系人ID ，用以更新编辑联系人信息
                cancelMap: {
                    '1': '未消费随时退',
                    '2': '不允许退订',
                    '4': '在游玩日期前退票',
                    '8': '固定日期前退',
                    '12': '有效期内不退',
                    '16': '需人工审核'
                },
                checkedIdx:-1,
                couponObj:[],//优惠券列表
                couponCodeList:[],//已选择的优惠券编码
                categoryCode: '',//商品类型编码
                commodityCode: '',//商品编号
                merchantCode: '',//商户编号
                couponInfoEntity:{},
                discountPrices:0,
                timeList: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).timeList ? JSON.parse(localStorage.getItem('dateObj')).timeList : [],
                timeIndex: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).timeIndex ? JSON.parse(localStorage.getItem('dateObj')).timeIndex : -1,
                maleAppoint: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).maleAppoint ? JSON.parse(localStorage.getItem('dateObj')).maleAppoint : false,
                chooseTime: localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).chooseTime ? JSON.parse(localStorage.getItem('dateObj')).chooseTime : null,
                exclude: [1659],
                superpositionList:[],
                couponpositionList:[],
                couponPrices:0,
                playIndex: (localStorage.getItem("dateObj") && JSON.parse(localStorage.getItem('dateObj')).playIndex) ? JSON.parse(localStorage.getItem('dateObj')).playIndex : [],
                tipsShow: false,

                userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
            }
        },
        computed: {
            finalPrices:function() {
                const { count, price, discount, coupon } = this
                const basetotal = Math.round((price * count -this.couponPrices) * 100) / 100

                // if (discount) {
                //     return  (basetotal * discount/100)
                // } else if(coupon) {
                //     return (basetotal - coupon)
                // }

                return basetotal
            },
            totalPrices:function(){
                const { count, price, discount, coupon } = this
                const basetotal =  Math.round((price*100) * count)/100
                return basetotal
            },
        },
        watch: {
            count: function(val) {
                if (val > 100) {
                    this.count = 100
                    payPublic.showPrompt('您最多可订100张票！')
                }
                if ( val <= 0) {
                    this.count = 1
                }
            },
        },
        mounted() {
            const _this = this

            _this.minHeight = document.documentElement.clientHeight
            if (payPublic.isClient()) {
                payPublic.toToken(function () {
                    if (_this.userInfo) {
                        _this.initData(_this.userInfo)
                        _this.publicWay(_this.userInfo)
                    } else {
                        _this.$router.go(-1)
                    }
                })
            } else {
                payPublic.loginCheck(function () {
                    _this.initData(_this.userInfo)
                    _this.publicWay(_this.userInfo)
                })
            }

            

            /**
             * 微信签名分享
             */
            // if (util.isWeiXin()) {
            //     const shareData = typeof (shareData) === 'undefined' ? {
            //         title: _this.PAGE_TITLE,
            //         desc: _this.SHARE_TEXT,
            //         imgUrl: _this.SHARE_IMG,
            //         link: window.location.href.split('#')[0]
            //     } : shareData;

            //     _this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + _this.WX_APPID).then((response) => {
            //         util.initWxConfig(response.data.data, shareData)
            //     })
            // }
        },
        methods: {
            initData(info){
                const _this = this
                _this.$nextTick(()=> {
                    const { scenicId, ticketId, activityTicket } = _this.$route.query
                    // 获取门票名称与预订须知信息
                    _this.$http.get(`/api/wtcp-ecrm/public/scenicTicket/findByScenicId?scenicId=${scenicId}`).then((res) => {
                        const data = res.data.data
                        for (const key in data) {
                            if (Object.hasOwnProperty.call(data, key)) {
                                const item = data[key]
                                item.forEach(element => {

                                    if (element.ticketId * 1 === ticketId * 1) {
                                        _this.ticketInfo = element
                                        document.title = element.alias
                                        _this.getunitPriceData(activityTicket,info);
                                        _this.categoryCode = 1//商品类型编码

                                        _this.commodityCode = element.platCode//商品编号
                                        _this.merchantCode = element.deptCode//商户编号

                                    }
                                });
                            }
                        }
                    }).then(()=>{
                        const record = {
                            "browseType": 1,  // 浏览商品类型:1-门票 2-酒店 3-餐饮 4-文创产品 5-租车 6-旅游线路
                            "commodityId": ticketId,
                        }
                        // payPublic.recordSaved(record, info)
                    })
                })
            },
            // 分时预约
            getAppoint(date){
                this.$http.get('/api/wtcp-ecrm/public/ticket/hjly7/division/info?ticketId=' + this.$route.query.ticketId + '&tourDate=' + date).then((res) => {
                    if(res.data.status == 1){
                        const info = res.data.data.inventoryData
                        // 库存类型inventoryType  NONE：无库存 DATE_INVENTORY：日期库存 DIVISION_INVENTORY：分时库存 FLIGHT_INVENTORY：班次库存
                        if(info.inventoryType === 'DIVISION_INVENTORY'){
                            this.maleAppoint = true
                            this.timeList = info.divisionInventoryData.divisionDataList
                        }
                    }
                })
            },
            changeTime(item,index){
                this.timeIndex = index+1
                const normTime = item.divisionName.replace(/：/g, ':').split('-')
                this.chooseTime = {
                    controlStartTime: normTime[0].length < 8 ? (normTime[0].length < 5 ? '0' + normTime[0] + ':00' : normTime[0] + ':00') : normTime[0],
                    controlEndTime: normTime[1].length < 8 ? (normTime[1].length < 5 ? '0' + normTime[1] + ':00' : normTime[1] + ':00') : normTime[1],
                    timeCode: item.divisionCode
                }
            },
            couponsBtn() {
                if (this.preferentialList.length > 0) {
                    this.preferenShow = true
                } else {
                    this.preferenShow = false
                }
            },
            closeBtn() {
                this.preferenShow = false
            },
            // batchBtn(item,index) {
            //     this.couponCodeList = []
            //     const _item = item.couponInfoEntity
            //     this.preferentialList.forEach(el =>{
            //         if(el.couponCode == item.couponCode){
            //             el.current = !el.current
            //         }else{
            //             el.current = false
            //         }
            //     })
            //     this.checkedIdx = index
            //     if(item.current){
            //         this.couponInfoEntity = item.couponInfoEntity;
            //     }else{
            //         this.couponInfoEntity  = {}
            //     }
            //     this.preShow = item.couponInfoEntity.name
            //     if(JSON.stringify(this.couponInfoEntity) === '{}'){
            //         // this.finalPrices = this.totalPrices
            //     }else{
            //         this.preShow = item.couponInfoEntity.name
            //         this.couponCodeList.push(item.couponCode)
            //         if(_item.couponType == '157001'){//满减券
            //             this.discountPrices = item.couponInfoEntity.preferentialQuota
            //             this.discount = null
            //             this.coupon = item.couponInfoEntity.preferentialQuota

            //         }
            //         if(_item.couponType == '157002'){//折扣券
            //             this.discountPrices = (this.totalPrices * (1-_item.preferentialQuota/100)).toFixed(2)
            //             this.coupon = null
            //             this.discount = item.couponInfoEntity.preferentialQuota

            //         }
            //     }
            //     this.preferenShow = false
            // },
            batchBtns(item,index) {
                const _this = this
                let nnum=item.consumeMoney
                let popusNum=0
                let showSuper=false
                _this.couponpositionList = _this.superpositionList
                _this.discountPrices=0
                if(_this.superpositionList.length==0){
                    if(item.consumeMoney>_this.totalPrices){
                        payPublic.showPrompt(`您的消费金额未达到使用要求`)
                    }else{
                        item.current = !item.current
                        _this.superpositionList.push(item)
                    }
                }else{
                    let array=[]
                    _this.preferentialList.forEach((el,indexs) =>{
                        if(el.current){
                            if(index==indexs){
                                item.current = !item.current
                                showSuper=true
                            }else{
                                array.push(el)
                            }
                        }
                    })
                    _this.superpositionList = array
                    for(let i=0;i<_this.superpositionList.length;i++){
                        if(_this.superpositionList[i].superposition!=item.superposition){
                            payPublic.showPrompt(`不可叠加优惠券只能单独使用`)
                            return
                        }else{
                           if(_this.superpositionList[i].superposition==1){
                              payPublic.showPrompt(`不可叠加优惠券只能单独使用`)
                              return
                           }
                            if(_this.superpositionList[i].superposition==0){
                                nnum +=_this.superpositionList[i].consumeMoney
                            }
                        }
                    }
                    if(!showSuper){
                        item.current = !item.current
                    }
                    _this.discountPrices = nnum
                    if(nnum>_this.totalPrices){
                        item.current = false
                        payPublic.showPrompt(`您的消费金额未达到使用要求`)
                    }
                }
                _this.couponpositionList = []
                _this.couponCodeList = []
                _this.preferentialList.forEach(el =>{
                    if(el.current){
                        popusNum +=el.denomination
                        _this.couponpositionList.push(el)
                        _this.couponCodeList.push(el.id)
                    }
                })
                _this.couponPrices = popusNum
            },
            //默认选中优惠券
            couponsdefault(array){
                const _this = this
                let nostackindex = -1;
                let nostackmoney = 0;
                let stackPrices = 0;
                let stackmoney = 0;
                _this.couponPrice=0;
                _this.couponpositionList = []
                _this.couponCodeList=[]
                array.forEach((item,index)=>{
                    if(item.superposition==1){//不可叠加
                        if(_this.totalPrices>=item.consumeMoney){
                            if(nostackindex==-1){
                                nostackindex = index
                                nostackmoney = item.denomination
                            }
                        }
                    }
                    if(item.superposition==0){//可叠加
                        if(_this.totalPrices>=(item.consumeMoney+stackmoney)){
                            _this.couponpositionList.push(item)
                            stackmoney+=item.consumeMoney
                            stackPrices+=item.denomination
                        }
                    }
                })

                if(nostackmoney>=stackmoney && nostackindex != -1){
                    _this.couponPrices=nostackmoney
                    _this.preferentialList[nostackindex].current=true
                    _this.couponpositionList.push(_this.preferentialList[nostackindex])
                    _this.couponCodeList.push(_this.preferentialList[nostackindex].id)
                }else{
                    _this.couponPrices=stackPrices
                    _this.preferentialList.forEach(item=>{
                        _this.couponpositionList.forEach(el=>{
                            if(item.id==el.id){
                                item.current=true
                                _this.couponCodeList.push(item.id)
                            }
                        })
                    })
                }
                _this.superpositionList=_this.couponpositionList
            },
            //优惠券
            getAvailableCoupons(total){
                const _this = this
                if (payPublic.isClient()) {
                    payPublic.hasToken(function () {
                        const noLogin = localStorage.getItem('noLogin')
                        if (!noLogin) {
                            // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                            _this.getList(total,this.userInfo)
                        } else {
                            this.$router.go(-1)
                        }
                    })
                } else {
                    payPublic.loginCheck(function () {
                        // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                        _this.getList(total,this.userInfo)
                    })
                }
            },
            getList(total,userInfo) {
                const _this = this
                _this.discount = _this.coupon = null
                const data = {
                    commodityInfoModels: [
                        {
                            categoryCode: _this.categoryCode,//商品类型编码
                            commodityCode: _this.commodityCode,//商品编号
                            merchantCode: _this.merchantCode,//商户编号
                            total: total
                        }
                    ],
                    usedRange: 1
                }
                this.$http.get('/api/wtcp-activity/public/couponPackage/getCouponListByScenicId?access_token='+ userInfo.token+'&scenicId='+ _this.$route.query.scenicId).then((res) => {
                    let array = res.data.data
                    if(array){
                        array.forEach(item => {
                            item.preferentialShow = false
                            item.current = false
                            if(item.useEndTime){
                                item.useEndTime = item.useEndTime.substring(0,10)
                            }
                            if(item.useStartTime){
                                item.useStartTime = item.useStartTime.substring(0,10)
                            }
                        })
                        _this.preferList = array
                        _this.couponInfoEntity = {}
                        _this.preShow = array.length+'张优惠券可用'
                        _this.preferentialList = array
                        _this.couponObj = array
                        if(_this.preferentialList.length>0){
                            _this.couponsdefault(_this.preferentialList)
                        }
                    }else{
                        _this.couponObj = []
                        _this.couponInfoEntity = {}
                        _this.preferentialList = []
                    }
                })
            },
            //订票数量加减按钮
            add() {
                this.couponpositionList=[]
                this.couponPrices=0
                this.preferentialList.forEach(el =>{
                    el.current=false
                })
                const max = this.ticketInfo.ticketHjlyVO.orderMaxNum || 100
                this.count++
                if(max * 1 > 0 && this.count > max){
                    this.count = max
                    payPublic.showPrompt(`您最多可定${max}张门票`)
                }
                const orderInfo = JSON.parse(localStorage.getItem("dateObj"))
                orderInfo.count = this.count
                localStorage.setItem('dateObj', JSON.stringify(orderInfo))
                this.getAvailableCoupons(this.totalPrices)
            },
            subtract() {
                this.couponpositionList=[]
                this.couponPrices=0
                this.preferentialList.forEach(el =>{
                    el.current=false
                })
                const  min = this.ticketInfo.ticketHjlyVO.orderMinNum || 1
                this.count--
                if (this.count < min) {
                    this.count = min
                    payPublic.showPrompt(`您最少要定${min}张门票`)
                }
                this.getAvailableCoupons(this.totalPrices)
            },
            //添加预订人、游玩人列表弹框
            addPeople(type,checkType) {
                this.addPeoplePump = !this.addPeoplePump
                // 弹框
                switch (type) {
                    case 1: // 预订人列表
                        this.But1 = true
                        this.But2 = false
                        const orderInfo = JSON.parse(localStorage.getItem("dateObj"))
                        if(orderInfo && orderInfo.bookInfo){
                            this.orderPeople = orderInfo.id
                            this.selectIndex = orderInfo.bookInfo.order
                        }else{
                            this.orderPeople = ''
                            this.selectIndex = -1
                        }
                        break;
                    case 2: // 游玩人列表
                        if(checkType === 'radio'){
                            this.changeIndex = -1
                            this.But1 = false
                            this.But2 = false
                            const palyOneInfo = JSON.parse(localStorage.getItem("dateObj"))
                            if(palyOneInfo && palyOneInfo.playPeople){
                                this.playersList = palyOneInfo.playPeople
                                this.changeIndex = palyOneInfo.changeIndex
                            }else{
                                this.playersList = []
                                this.changeIndex = []
                            }
                        }else{
                            this.But1 = false
                            this.But2 = true
                            const playInfo = JSON.parse(localStorage.getItem("dateObj"))
                            if(playInfo && playInfo.playPeople){
                                this.playersList = playInfo.playPeople
                                this.playIndex = playInfo.playIndex
                            }else{
                                this.playersList = []
                                this.playIndex = []
                            }
                        }
                        break;
                    default:
                        break;
                }
                this.getPeopleData()
            },
            getPeopleData() {
                const _this = this
                if (payPublic.isClient()) {
                    payPublic.toToken(()=> {
                        // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                        if (this.userInfo) {
                            _this.publicWay(this.userInfo)
                        }else{
                            payPublic.goBack()
                        }
                    })
                } else {
                    payPublic.loginCheck(function () {
                        // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                        _this.publicWay(this.userInfo)
                    })
                }
            },
            publicWay(info){
                this.$http.get('/api/wtcp-member/public/contacts/page?access_token=' + info.access_token +'&deptCode=' + this.DEPT_CODE.DEPTCODE+ '&page=' + this.pageNo + '&size=' + 100 + '&userId=' + info.user.id).then(res => {
                    const data = res.data.data ? res.data.data.content : []
                    this.contactsList = data
                    
                    if (data.length < this.pageSize) {
                        this.infiniteAll = true
                    }
                    this.infiniteStatus = false
                })
            },
            // 底部加载
            windowScroll() {
                if (util.pullUpLoad()) {
                    this.infinite()
                }
            },
            infinite() {
                if (this.contactsList.length === 0) {
                    return;
                }
                if (this.infiniteAll) {
                    return;
                }
                if (this.infiniteStatus) {
                    return;
                }
                this.infiniteStatus = true;
                this.pageNo += 1;
                this.getPeopleData()
            },
            //点击朦胧位置
            coverOp() {
                this.addPeoplePump = false
                this.coastMxPump = false
                this.But1 = false
                this.But2 = false
            },
            //明细
            detailPay() {
                if(this.curticket !== -1 && this.ticketsCalenda[this.curticket].salePrice >0){
                    this.coverOpacity = !this.coverOpacity
                    this.coastMxPump = !this.coastMxPump
                }
            },
            //门票单价日历
            getunitPriceData(activityTicket,info) {
                const { ticketId } = this.$route.query
                const active = activityTicket ? '&activityTicket=true' : ''
                const url = `/api/wtcp-ecrm/public/scenicTicket/findTicketListPrice?ticketId=${ticketId}${active}`
                this.$http.get(url).then(res => {
                    // 正式环境
                    const data = res.data.data
                    if(data){
                        const { priceList, ticketBuyRule, name } = data
                        if(ticketBuyRule){

                            const { maxAdvanceDays, minAdvanceDays, orderMinNum } = ticketBuyRule

                            const interval = this.getOrderInterval(maxAdvanceDays * 1, minAdvanceDays * 1)
                            if (activityTicket) {
                                const { ticketInfo } = data
                                this.ticketInfo.name = name
                                if (priceList.length > 0) {
                                    ticketInfo.bsId = priceList[0].bsId
                                    ticketInfo.ticketId = priceList[0].ticketId
                                }
                                this.ticketInfo = ticketInfo
                            }
                            // maxAdvanceDays 预定最多提前天数 表示可预订未来几天内的商品,空字符串表示不限制
                            // minAdvanceDays 预定至少提前天数 0 表示可以预订当天的,空字符串表示不限制
                            // todayEndTime 提前多少天的几点 与至少提前天数合并使用,空字符串表示不限制
                            // orderEndTime 下单结束时间
                            // orderStartTime 下单开始时间
                            // linkRealName	boolean预定人实名信息 true-需要 false-不需要 该票型默认实名
                            // playerRealName	integer($int32)1表示游玩人实名制 0表示游玩人非实名制
                            if (priceList.length > 0) {
                                priceList.map((item, index) => {
                                    item.index = index
                                    item.time = formatDate(item.dailyPriceDate, 'MM月dd日');
                                    item.curYear = formatDate(item.dailyPriceDate, 'yyyy');
                                    item.curMonth = formatDate(item.dailyPriceDate, 'MM');
                                    item.curDay = formatDate(item.dailyPriceDate, 'dd');
                                    item.bookStatus = true // 所有订票状态预设为可定
                                    // 库存为0不可订
                                    if(item.balanceNum === 0){
                                        item.bookStatus = false
                                    }
                                    const dateLocalstr = item.dailyPriceDate.replace(/-/g, '/')
                                    const orderSec = (new Date(dateLocalstr)).getTime()  // 每张票日期转化为毫秒数
                                    // 不在可规则订票区间内不可订
                                    if (maxAdvanceDays) {
                                        if (orderSec > interval.endSec) {
                                            item.bookStatus = false
                                        }
                                    }
                                    if (minAdvanceDays*1 > 0) {
                                        if (orderSec < interval.startSec) {
                                            item.bookStatus = false
                                        }
                                    }
                                })
                                this.ticketsCalenda = priceList
                                const booklist = priceList.filter(item=> item.bookStatus)
                                // this.count = orderMinNum || 1
                                // 首次进入页面且价格日历中有可定的票则默认当前选择可定的第一天，单价为当前票价，有订票数量下限是数量为下限否则为1
                                if (booklist.length > 0 && this.curticket === -1) {
                                    this.curticket = 'nochoose'
                                    // this.curticket = booklist[0].index
                                    // this.chooseData = booklist[0].dailyPriceDate
                                    // this.price = booklist[0].salePrice
                                    this.count = orderMinNum ? orderMinNum*1 : 1
                                    this.getAppoint(this.chooseData)
                                } else if (booklist.length === 0) {  // 价格日历中无可定的票
                                    this.curticket = -1
                                    this.price = 0
                                }
                            }

                        }else{
                            if (priceList.length > 0) {
                                priceList.map((item, index) => {
                                    item.index = index
                                    item.time = formatDate(item.dailyPriceDate, 'MM月dd日');
                                    item.curYear = formatDate(item.dailyPriceDate, 'yyyy');
                                    item.curMonth = formatDate(item.dailyPriceDate, 'MM');
                                    item.curDay = formatDate(item.dailyPriceDate, 'dd');
                                    item.bookStatus = true // 所有订票状态预设为可定
                                    // 库存为0不可订
                                    if(item.balanceNum === 0){
                                        item.bookStatus = false
                                    }
                                })
                                this.ticketsCalenda = priceList
                                const booklist = priceList.filter(item=> item.bookStatus)
                                // this.count = orderMinNum || 1
                                // 首次进入页面且价格日历中有可定的票则默认当前选择可定的第一天，单价为当前票价，有订票数量下限是数量为下限否则为1
                                if (booklist.length > 0 && this.curticket === -1) {
                                    this.curticket = 'nochoose'
                                    // this.curticket = booklist[0].index
                                    // this.chooseData = booklist[0].dailyPriceDate
                                    // this.price = booklist[0].salePrice
                                    this.getAppoint(this.chooseData)
                                } else if (booklist.length === 0) {  // 价格日历中无可定的票
                                    this.curticket = -1
                                    this.price = 0
                                }
                            }
                        }
                    }
                }).then(()=>{
                    this.$nextTick(() => {
                        this.ticketSwiper = new Swiper('.ticket-swiper', {
                            slidesPerView : 'auto',
                            spaceBetween: 10,
                            initialSlide: this.curticket != 'nochoose' ? this.curticket : ''
                        })
                    })
                    // this.getList(this.totalPrices,info)
                })
            },
            selecData(item, index) {
                this.price = item.salePrice
                this.count = 1
                this.curticket = index
                this.chooseData = item.dailyPriceDate
                this.timeIndex = -1
                // this.timeList = []
                this.chooseTime = null
                this.getAppoint(item.dailyPriceDate)
                this.getAvailableCoupons(this.totalPrices)
            },
            openTips() {
                this.noticeShow = true
            },
            closrNotice() {
                this.noticeShow = false
            },
            submit() {
                const _this = this
                const idMap = {
                    'idCard': 1,
                    'passport': 2,
                    'taiwanPass': 3,
                    'hongkongAcaoPass': 4,
                    'taiwanCompatriotCertificate': 5,
                    'studentCard': 6,
                    'militaryCard': 7
                }
                const { playersList, playCard, ticketInfo, exclude } = _this
                let { orderPeople, count } = _this
                const playerCount = playersList.length // 游玩人数量
                let orderCardList = [] // 包含证件信息的预订人数组 每一项包含证件类型值和证件号码
                let playersCardList = [] // 包含证件信息的游玩人数组 每一项包含证件类型值和证件号码
                if(exclude.includes(ticketInfo.ticketId)){
                    playersList.map(item => {
                        if(item.acquiesce == 1){
                            orderPeople = item
                        }
                    })
                    count = playerCount
                }
                if(orderPeople){
                    for (const key in idMap) {
                        if (Object.hasOwnProperty.call(idMap, key)) {
                            const element = idMap[key]
                            if (orderPeople[key]) {
                                 orderCardList.push({
                                    type: element,
                                    cardNum: orderPeople[key]
                                })
                            }
                        }
                    }
                }
                playersList.map((item) => {
                    for (const key in idMap) {
                        if (Object.hasOwnProperty.call(idMap, key)) {
                            const element = idMap[key]
                            if (item[key]) {
                                playersCardList.push({
                                    visitorName: item.name,
                                    visitorPhone: item.phone,
                                    visitorIdentity: item[key],
                                    certificateType: element
                                })
                            }
                        }
                    }
                })
                if(!_this.chooseData){
                    payPublic.showPrompt(`请选择游玩日期`)
                }else if(_this.maleAppoint && !_this.chooseTime){
                    payPublic.showPrompt(`请选择预约时段`)
                }else if(!orderPeople && !_this.exclude.includes(_this.ticketInfo.ticketId)) {
                    payPublic.showPrompt(`请添加预定人以方便接收预定信息`)
                } else if(orderPeople && orderCardList.length === 0)  {
                    payPublic.showPrompt(`请补充预订人证件信息`)
                } else if(playerCount == 0 && _this.exclude.includes(_this.ticketInfo.ticketId)) {
                    payPublic.showPrompt(`您至少需要添加一位游玩人信息`)
                } else if(!orderPeople && _this.exclude.includes(_this.ticketInfo.ticketId)) {
                    payPublic.showPrompt(`您需要设置一位游玩人为本人，来接收预订信息`)
                } else if(playerCount > count && !_this.exclude.includes(_this.ticketInfo.ticketId)) {
                    payPublic.showPrompt(`您需要删除多余的${playerCount - count}位游玩人或者请添加购票数量`)
                } else if(playerCount < count && !_this.exclude.includes(_this.ticketInfo.ticketId)) {
                    payPublic.showPrompt(`您还需要添加${count - playerCount}位游玩人信息`)
                } else if(playerCount > playersCardList.length) {
                    payPublic.showPrompt(`您还需要补充${playerCount - playersCardList.length}位游玩人的证件信息！`)
                } else if(_this.exclude.includes(_this.ticketInfo.ticketId) && ticketInfo.ticketHjlyVO.orderMaxNum && playerCount > Number(ticketInfo.ticketHjlyVO.orderMaxNum)) {
                    payPublic.showPrompt(`您最多能添加${ticketInfo.ticketHjlyVO.orderMaxNum}位游玩人`)
                } else {
                    const params = {
                        "reserveName": orderPeople && orderPeople.name ? orderPeople.name : '', // 预订人姓名
                        "reserveIdentity": (orderCardList[0] && orderCardList[0].cardNum) ? orderCardList[0].cardNum : '', // 预定人证件号码
                        "reserveIdentityType": (orderCardList[0] && orderCardList[0].type) ? orderCardList[0].type : '',
                        "reservePhone": orderPeople && orderPeople.phone ? orderPeople.phone : '', // 预订人手机号
                        "orderResource": Number(payPublic.isClient()) ? Number(payPublic.isClient()) : 2,  //订单来源(1-Ios 2-Android)
                        "remark": "", // 订单备注
                        "distributionChannel": 1, //分销渠道(1-公众服务平台 2-美团 3-智游宝)
                        "goodsCode": 1, //商品模块(1-门票 2-客房 3-餐饮 4-文创 5-租车 6-线路)
                        "merchants": [
                            {
                                "merchantsId": ticketInfo.bsId, //商户id
                                "merchantsRemark": "", //商户留言
                                "coupons":[],  //优惠券
                                "vouchers": _this.couponCodeList,  //优惠券
                                "orderCommoditys": [
                                    {
                                        "commodityId": ticketInfo.ticketId,
                                        "commodityNum": count, //商品数量
                                        "visitDate": _this.chooseData,
                                        "visitors": playersCardList,
                                        "timeControl": _this.chooseTime
                                    }
                                ]
                            }
                        ]
                    }
                    if (payPublic.isClient()) {
                        payPublic.hasToken(function () {
                            const noLogin = localStorage.getItem('noLogin')
                            if (!noLogin) {
                                _this.createOrder(params)
                            } else {
                                _this.$router.go(-1)
                            }
                        })
                    } else {
                        payPublic.loginCheck(function () {
                            _this.createOrder(params)
                        })
                    }
                }
            },
            // 生成订单
            createOrder(params) {
                // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
                this.tipsShow = true
                this.$http.post(`/api/wtcp-ecrm/order/common/save?access_token=${this.userInfo.access_token}`, params).then((response) => {
                    if (response.data.status == 1) {
                        const data = response.data.data
                        data.body = this.ticketInfo.alias   //商品名称
                        localStorage.setItem('dateObj', '')
                        
                        //判断是否是从购物车跳转methodPay,不是清空store对应状态
                        this.$store.commit('changeCarlistFrom','')
                        this.$router.replace({path: '/methodPay', query: data})
                    } else {
                        this.tipsShow = false
                        payPublic.showPrompt(response.data.msg.replace('下单失败:未支付订单下单失败：', ''))
                    }
                })
            },
            hideCendar() {
                this.visibility = false
            },
            clickDay(date, balanceNum) {
                this.visibility = false

                this.price = balanceNum
                this.count = 1
                this.chooseData = date
                this.ticketsCalenda.map((item, index) => {
                    if (item.dailyPriceDate === date) {
                        this.ticketSwiper.slideTo(index, 1000, false);//切换到第index个slide，速度为1秒
                        this.curticket = index
                    }
                })
                this.timeIndex = -1
                this.chooseTime = null
                this.getAppoint(date)
            },
            calendarClick() {
                this.visibility = true
            },
            // 传入最多提前天数和最少提前天数分别返回对应时间区间的开始时间结束时间以及开始时间和结束时间的毫秒数
            getOrderInterval(max, min) {
                const interval = {
                    endSec: null,
                    startDate: null,
                    endDate: null,
                    startDate: null
                }
                const now = new Date()
                const str = now.toLocaleDateString()
                const today = new Date(str)
                const todayIndex = today.getDate()

                interval.endSec = (new Date()).setDate(todayIndex + max)
                interval.startSec = (new Date()).setDate(todayIndex + min -1)

                interval.endDate = new Date(interval.endSec)
                interval.startDate = new Date(interval.startSec)

                return interval
            },
            addReplace(val,type){
                if(val === 'radio'){
                    this.addPeople(1,type)
                }else{
                    this.addPeople(2,type)
                }
            },
            changeInfoList(val1,val2){
                if(val1 === 'radio'){
                    this.orderPeople = val2
                }else{
                    this.playersList = val2
                }
            },
            closeContactList(val){
                this.addPeoplePump = val
                this.coverOpacity = val
            }
        },
        beforeRouteLeave (to, from, next) {
            if (to.name === 'addContact') {
                const dateObj = {
                    playersList: this.playersList,
                    curticket: this.curticket,
                    chooseData: this.chooseData,
                    count: this.count,
                    price: this.price,
                    orderPeople: this.orderPeople,
                    editId: this.editId,
                    timeList: this.timeList,
                    timeIndex: this.timeIndex,
                    chooseTime: this.chooseTime,
                    maleAppoint: this.maleAppoint
                }
                localStorage.setItem('dateObj', JSON.stringify(dateObj))
            } else {
                localStorage.removeItem('dateObj')
            }
            next()
        }
    }
